// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__AiK+M","Btns":"style_Btns__9p0AJ","Form":"style_Form__PInVG","ProArts":"style_ProArts__JqnKT","SubTypes":"style_SubTypes__2Nmtl"};